export default import.meta.ROLLUP_FILE_URL_1GLDz2qWA0MQNKAUdyvgTA